export default __webpack_public_path__ + "static/recruit-banner-67c6e0c3730de5d455423162751a6b1e.svg";